export default __webpack_public_path__ + "static/media/640_dummy2016-massagestudio01-de.d9c2e8b7.png";